/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMapBolt = createReactComponent("outline", "map-bolt", "IconMapBolt", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v7.5", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

export { IconMapBolt as default };
//# sourceMappingURL=IconMapBolt.mjs.map
